import { render, staticRenderFns } from "./DisplayListYjjM.vue?vue&type=template&id=0704c02d&scoped=true&"
import script from "./DisplayListYjjM.vue?vue&type=script&lang=js&"
export * from "./DisplayListYjjM.vue?vue&type=script&lang=js&"
import style0 from "./DisplayListYjjM.vue?vue&type=style&index=0&id=0704c02d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704c02d",
  null
  
)

export default component.exports